import { Injectable } from '@angular/core';
import { Country } from '../models/domain/Country';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { Category } from '../models/domain/Category';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService extends BaseService<Category> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService,
    public authService: AuthenticationService
  ) {
    super(http, `${environment.apiUrl}/v1/category`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public GetCategoryByTenantIdAsync(tenantId: number): Observable<HttpResponse<Category[]>> {
    this.loadingService.showLoading();

    return this.httpClient.get<Category[]>(`${this.baseApiUrl}/${tenantId}/categories`, { observe: "response" })
      .pipe(tap(response => {
        this.loadingService.hideLoading();
      }),
        catchError(error => {
          // Propagate the error properly to the ErrorInterceptor
          this.loadingService.hideLoading();
          return throwError(() => error); // Make sure to throw the error properly
        })
      );
  }
}